import Entity from '@/models/entities/Entity';
import { Category } from '@/models/entities/Category';

export class ProductionTime implements Entity {
  public id: number = 0;
  public name: string = '';
  public categories: Category[] = [];
  public options: ProductionTimeOption[] = [];

  constructor(initData: Partial<ProductionTime>) {
    Object.assign(this, initData);
  }
}

export class ProductionTimeOption implements Entity {
  public id: number = 0;
  public name: string = '';
  public pricePerPair: number = 0;
  public withLogo: boolean = false;

  constructor(initData: Partial<ProductionTimeOption>) {
    Object.assign(this, initData);
  }
}
